import { bigScreen_navMenuVertical_children } from "materials/navMenuVertical/menus/index.js"

export default {
  name: "树形菜单",
  id: "",
  type: "cxNavMenuVertical",
  children: bigScreen_navMenuVertical_children,
  sort: 130
}
